module.exports = __webpack_public_path__ + "fonts/Fontfabric - Uni Sans Book Italic.65752432.ttf";